// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-viewer-outer-container {
    position: relative;
}

.skitterbook-file-loader-container {
    max-width: 75vw;
    width: fit-content;
}

.skitterbook-video-file-loader-container {

}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookVideoFileLoader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;AAEA","sourcesContent":[".skitterbook-viewer-outer-container {\r\n    position: relative;\r\n}\r\n\r\n.skitterbook-file-loader-container {\r\n    max-width: 75vw;\r\n    width: fit-content;\r\n}\r\n\r\n.skitterbook-video-file-loader-container {\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
